// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"39d33283","480":"90d096dd","747":"108dceea","928":"e491b24b","984":"4432d628"}[chunkId] + ".chunk.js";
};